import ClickableDescr from './ClickableDescr'

export default ClickableDescr
